import React from 'react';
import styled from 'styled-components';
import LanguageSelect from './Common/LanguageSelect';

// import telegram from '../../img/telegram.svg';

const Section = styled.div`
  position: fixed;
  display: ${props => props.pathname === "/clinics" ? "none" : "flex"};
  justify-content: center;
  align-items: center;
  bottom: 0;
  left: 0;
  height: 50px;
  width: 100%;
  z-index: 1000;

  @media (max-width: 920px) {
    display: none;
  };
`

const BackgroundColor = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.9;
  z-index: 10;

  @media (max-width: 920px) {
   background-color: black;
   opacity: 1;
  };
`

const SectionBox = styled.div`
  z-index: 20;
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 1360px;

`
const TextBox = styled.div`
  color: white;
  margin-left: auto;
  margin-right: 40px;
  font-size: 12px;
  font-weight: 300;
  line-height: 22px;

  @media (max-width: 768px) {
    margin-left: auto;
    margin-right: auto;
  };
`

const Footer = ({ language, Translation, TranslationHandler, KoreaLanguageHandler, EnglishLanguageHandler, pathname }) => {

  return (
    <div>
      <Section pathname={pathname}>
        <SectionBox>
          {/* <LanguageSelect
            size={'deskTop'}
            style={{ marginLeft: 40 }}
            language={language}
            Translation={Translation}
            TranslationHandler={TranslationHandler}
            KoreaLanguageHandler={KoreaLanguageHandler}
            EnglishLanguageHandler={EnglishLanguageHandler}
          /> */}
          <TextBox>
            <p>Copyright ⓒ AngerLabs. All rights reserved.</p>
          </TextBox>
        </SectionBox>
        <BackgroundColor />
      </Section>
    </div>
  );
};

export default Footer;